import repository from './repository';
import axios from 'axios';

const API = process.env.VUE_APP_API_URL;

let LogRepository = repository('/log');

LogRepository.getAllLogCategories = () => {
    return axios.get(API + '/log/categories');
};

LogRepository.getAllFilesForCategory = (categoryName) => {
    return axios.post(API + '/log/files', { category: categoryName });
};

LogRepository.downloadFile = (categoryName, fileName) => {
    return axios.post(API + '/log/file', { category: categoryName, file: fileName });
};

export default LogRepository;
